/* Wishlist store: product handles saved on this device (localStorage), up to 20.
   No server, no app. Emits `antarti:wishlist` on every change; cards and the header
   heart listen. The wishlist page (S15) renders the saved handles via the Section
   Rendering API. */

(() => {
  'use strict';

  const KEY = 'antarti.wishlist.v1';
  const MAX = 20;
  const A = (window.antarti = window.antarti || {});

  function read() {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch {
      /* private mode or storage disabled: the wishlist just doesn't persist */
    }
    document.dispatchEvent(new CustomEvent('antarti:wishlist', { detail: { list } }));
  }

  A.wishlist = {
    list: () => read(),
    has: (handle) => read().includes(handle),
    add(handle) {
      const list = read();
      if (!list.includes(handle)) write([handle, ...list]);
    },
    remove(handle) {
      write(read().filter((h) => h !== handle));
    },
    toggle(handle) {
      this.has(handle) ? this.remove(handle) : this.add(handle);
    },
    clear: () => write([]),
  };

  /* Header heart shows a dot when the list isn't empty. */
  function syncHeader() {
    const count = read().length;
    document.querySelectorAll('.site-header__wishlist').forEach((el) => {
      el.classList.toggle('has-items', count > 0);
      el.setAttribute('data-count', String(count));
    });
  }
  document.addEventListener('antarti:wishlist', syncHeader);
  window.addEventListener('storage', (e) => e.key === KEY && syncHeader());
  syncHeader();
})();
